import {fonts, colors} from '../../../../theme';

const styles = (theme) => ({
  projectsBackgroundDark: {
    backgroundColor: colors.darkThemeDarkGreyBackground,
  },
  serviceTitleDark: {
    fontFamily: fonts.base,
    fontWeight: 600,
    fontSize: 48,
    color: colors.darkPrimary,
    marginBottom: 0,
    textAlign: 'center',
  },
  projectTitleDark: {
    fontFamily: fonts.base,
    fontWeight: 600,
    color: '#A6B0D4',
    fontSize: 16,
  },
  projectDescriptionDark: {
    fontFamily: fonts.base,
    color: colors.darkThemeWhiteText,
    fontSize: 14,
  },
});

export default styles;
